// Generated by purs version 0.15.10
import * as Control_Alternative from "../Control.Alternative/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_String_Regex from "../Data.String.Regex/index.js";
import * as Data_String_Regex_Flags from "../Data.String.Regex.Flags/index.js";
import * as Data_String_Regex_Unsafe from "../Data.String.Regex.Unsafe/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Random from "../Effect.Random/index.js";
var compare = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordString);
var fromJust = /* #__PURE__ */ Data_Maybe.fromJust();
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe);
var guard = /* #__PURE__ */ Control_Alternative.guard(Data_Maybe.alternativeMaybe);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Data_Maybe.bindMaybe);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Maybe.applicativeMaybe);
var UUIDv4 = /* #__PURE__ */ (function () {
    function UUIDv4(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    UUIDv4.create = function (value0) {
        return function (value1) {
            return new UUIDv4(value0, value1);
        };
    };
    return UUIDv4;
})();
var showUUIDv4 = {
    show: function (v) {
        return "(UUIDv4 " + (v.value0 + ")");
    }
};
var eqUUIDv4 = {
    eq: function (v) {
        return function (v1) {
            return v.value0 === v1.value0;
        };
    }
};
var ordUUIDv4 = {
    compare: function (v) {
        return function (v1) {
            return compare(v.value0)(v1.value0);
        };
    },
    Eq0: function () {
        return eqUUIDv4;
    }
};
var toString = function (v) {
    return v.value0;
};
var rxChars = /* #__PURE__ */ Data_String_Regex_Unsafe.unsafeRegex("-?")(Data_String_Regex_Flags.global);
var hexRadix = /* #__PURE__ */ fromJust(/* #__PURE__ */ Data_Int.radix(16));
var render = function (is) {
    var chunk = function (i) {
        return function (j) {
            return Data_String_Common.joinWith("")(map(Data_Int.toStringAs(hexRadix))(Data_Array.slice(i)(j)(is)));
        };
    };
    return Data_String_Common.joinWith("-")([ chunk(0)(8), chunk(8)(12), chunk(12)(16), chunk(16)(20), chunk(20)(32) ]);
};
var unsafeFromInts = function (is) {
    return new UUIDv4(render(is), is);
};
var make$prime = function (dictApplicative) {
    var pure1 = Control_Applicative.pure(dictApplicative);
    var map1 = Data_Functor.map((dictApplicative.Apply0()).Functor0());
    var sequence1 = sequence(dictApplicative);
    return function (rand) {
        var y = [ rand(8)(11) ];
        var x = [ rand(0)(15) ];
        var x3 = append1(x)(append1(x)(x));
        var x4 = append1(x3)(x);
        var x8 = append1(x4)(x4);
        var x12 = append1(x8)(x4);
        var uuid = append1(x8)(append1(x4)(append1([ pure1(4) ])(append1(x3)(append1(y)(append1(x3)(x12))))));
        return map1(unsafeFromInts)(sequence1(uuid));
    };
};
var make$prime1 = /* #__PURE__ */ make$prime(Effect.applicativeEffect);
var make = function (dictMonadEffect) {
    return Effect_Class.liftEffect(dictMonadEffect)(make$prime1(Effect_Random.randomInt));
};
var fromInts = function (is) {
    return discard(guard(Data_Array.length(is) === 32))(function () {
        return bind(Data_Array.index(is)(12))(function (rd) {
            return discard(guard(rd === 4))(function () {
                return bind(Data_Array.index(is)(16))(function (yd) {
                    return discard(guard(yd >= 8 && yd < 12))(function () {
                        return pure(unsafeFromInts(is));
                    });
                });
            });
        });
    });
};
var fromString = function (str) {
    return bindFlipped(fromInts)(traverse(Data_Int.fromStringAs(hexRadix))(Data_String_Regex.split(rxChars)(str)));
};
export {
    make,
    make$prime,
    toString,
    fromString,
    eqUUIDv4,
    ordUUIDv4,
    showUUIDv4
};
